import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MotionConfig } from 'motion/react'
import './index.css'
import App from './App.jsx'
import { PopupProvider } from "./components/PopupContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BlendyProvider } from "@/contexts/BlendyContext";
import ErrorBoundary from "@/components/ErrorBoundary";

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <MotionConfig reducedMotion="user">
      <BlendyProvider>
        <PopupProvider>
          <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || "YOUR_GOOGLE_CLIENT_ID"}>
            <TooltipProvider>
              <ErrorBoundary>
                <App />
              </ErrorBoundary>
            </TooltipProvider>
          </GoogleOAuthProvider>
        </PopupProvider>
      </BlendyProvider>
    </MotionConfig>
  </StrictMode>,
)